import { Directive, Input, Output, EventEmitter, HostListener, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appFilterToggle]',
  standalone: false
})
export class FilterToggleDirective {
  @Input() appFilterToggle: boolean;
  @Output() appFilterToggleChange = new EventEmitter<boolean>();

  @HostListener('click')
  onClick() {
    this.appFilterToggleChange.emit(!this.appFilterToggle);
  }
}

@Directive({
  selector: '[appFilterAction]',
  standalone: false
})
export class FilterActionDirective implements OnChanges {
  @Input() appFilterAction: 'clear' | 'showAll';
  @Input() allShow: boolean;
  @Output() allShowChange = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  @HostListener('click')
  onClick() {
    if (this.appFilterAction === 'showAll') {
      this.allShow = !this.allShow;
      this.allShowChange.emit(this.allShow);
      this.updateText();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateText();
  }

  private updateText() {
    if (this.appFilterAction === 'showAll') {
      this.el.nativeElement.innerText = this.allShow ? 'Hide All' : 'Show All';
    } else if (this.appFilterAction === 'clear') {
      this.el.nativeElement.innerText = 'Clear All';
      if (!this.el.nativeElement.classList.contains('none-select')) {
        this.el.nativeElement.classList.add('none-select');
      }
    }
  }
}
